/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_Sentry_DescInputs */

const en_privacy_section_5_sentry_desc = /** @type {(inputs: Privacy_Section_5_Sentry_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`error monitoring and performance tracking.`)
};

const lv_privacy_section_5_sentry_desc = /** @type {(inputs: Privacy_Section_5_Sentry_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kļūdu uzraudzība un veiktspējas izsekošana.`)
};

/**
* | output |
* | --- |
* | "error monitoring and performance tracking." |
*
* @param {Privacy_Section_5_Sentry_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_sentry_desc = /** @type {((inputs?: Privacy_Section_5_Sentry_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_Sentry_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_sentry_desc(inputs)
	return en_privacy_section_5_sentry_desc(inputs)
});